import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { AppConfigService } from 'src/app/app-config.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { UserInfoModel } from '../types/GetUserInfoModel';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private isLoggedIn$$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	isLoggedIn$: Observable<boolean> = this.isLoggedIn$$.asObservable();

	constructor(
		private configService: AppConfigService,
		private httpClient: HttpClient,
		private cookieService: CookieService
	) {
		this.isLoggedIn$$.next(this.cookieService.check('CAPSLock'));
	}

	login() {
		this.isLoggedIn$$.next(true);
		window.location.href = this.configService.getConfig().loginUrl;
	}

	logout(): Observable<any> {
		this.isLoggedIn$$.next(false);
		return this.httpClient.post(this.configService.getConfig().logoutUrl, {});
	}

	isLoggedIn() {
		return this.isLoggedIn$$.value;
	}

	getUserInfo(): Observable<UserInfoModel> {
		return this.httpClient.get<UserInfoModel>(`${this.configService.getConfig().registrantApiUrl}/getUserInfo`);
	}
}
